// @owners { team: patients-team }
import { SPACING } from '@alto/design-library-tokens';
import { ActionSheetV2, Body, LgPadding } from '@alto/design-system';
import React from 'react';
import { getIsGskForYouUser } from '~shared/features/users/selectors/getIsGskForYouUser';
import { useSelectorShared } from '~shared/store';

export const GSK_FOR_YOU_FEE_DETAILS_COPY =
  'The delivery fee includes the cost to ship your order, as well as a pharmacy dispensing fee of $15.';

export const FeeDetailsActionSheet = () => {
  const isGskForYouUser = useSelectorShared(getIsGskForYouUser);

  return (
    <ActionSheetV2
      title="Fee details"
      analyticsName="fee details"
    >
      <LgPadding topPadding={SPACING.STATIC.NONE}>
        {isGskForYouUser ? <Body>{GSK_FOR_YOU_FEE_DETAILS_COPY}</Body> : null}
      </LgPadding>
    </ActionSheetV2>
  );
};
